















































import Swiper from 'swiper/js/swiper.js'
import { mapState } from 'vuex';

export default {
  name: 'DetailedScheme',
  data: () => ({
    swiper: null,
    progress: null
  }),
  props: {
    content: Object
  },
  computed: {
    ...mapState(['penthousesList', 'windowWidth']),
    windowWidth() {
      return this.innerWidth < 1200
    }
  },
  mounted() {
    this.updateSlideWidth()
    window.addEventListener('resize', () => {
      this.updateSlideWidth()
    });
    this.initSwiper()
    this.swiper.on('progress', (progress) => {
      this.progress = progress;
    })
    this.swiper.translateTo(-this.$refs.swiper.getBoundingClientRect().width * 0.3, 0, false, false);
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.updateSlideWidth()
    });
  },
  watch: {
  },
  methods: {
    initSwiper() {
      this.swiper = new Swiper(this.$refs.swiper, {
        freeMode: true,
        slidesPerView: 'auto',
        freeModeMomentum: false,
        watchOverflow: true,
        resistanceRatio: 0,
        watchSlidesProgress: true,
        watchSlidesVisibility: true
      });
    },
    updateSlideWidth() {
      document.querySelectorAll('.detailed-scheme__transparent-slide').forEach(item => {
        item.style.width = `${this.$refs.swiper.getBoundingClientRect().width}px`;
        item.style.minWidth = `${this.$refs.swiper.getBoundingClientRect().width}px`
        });
    }
  }
}
